import { render, staticRenderFns } from "./released.vue?vue&type=template&id=5dd201e6&scoped=true"
import script from "./released.vue?vue&type=script&lang=js"
export * from "./released.vue?vue&type=script&lang=js"
import style0 from "./released.vue?vue&type=style&index=0&id=5dd201e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd201e6",
  null
  
)

export default component.exports